/**
 * LoadingSpinner Component
 *
 * Simple loading spinner for async operations
 */

import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  message
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-3',
    lg: 'h-12 w-12 border-4',
  };

  return (
    <div className="flex flex-col items-center justify-center p-4">
      <div
        className={`${sizeClasses[size]} border-hue-cyan-border border-t-cyan-600 rounded-full animate-spin`}
      ></div>
      {message && (
        <p className="mt-2 text-sm text-ink-body">{message}</p>
      )}
    </div>
  );
};
